<script lang="ts">
  import Button from "../../components/atoms/Button.svelte";
  import Card from "../../components/atoms/Card.svelte";
  import Heading from "../../components/atoms/Heading.svelte";
  import ExtensibleContent from "../../components/molecules/ExtensibleContent.svelte";
  import InfoButton from "../../components/molecules/InfoButton.svelte";
  import useMovingFlow from "../../providers/useMovingFlow";

  const { send } = useMovingFlow();

  const onClickContinue = () => {
    send("NEXT");
  };
</script>

<Card>
  <Heading>Vi hjälper dig fixa elavtal till din nya bostad</Heading>
  <div class=" mb-4">
    <p class="mb-2">Detta behöver du för att kunna teckna ett elavtal hos oss:</p>
    <ul class=" list-disc ml-5">
      <li class="mb-2">
        <b>Ett elnätsavtal</b> för den bostad du vill teckna elavtal för.
        <div class="flex items-center space-x-1">
          <span>Läs mer om elnätsavtal</span><InfoButton iconSize={22} class="text-PurplePrimary"
            >Du kan inte välja var du tecknar ett elnätsavtal, utan det behöver du göra hos
            elnätsföretaget som äger och underhåller ledningarna i området där du bor/där aktuell
            fastighet finns.</InfoButton
          >
        </div>
      </li>
      <li class="mb-2">
        Ditt <b>anläggnings-ID</b>. Det består av 18 siffror och börjar med 735999. Uppgiften kan du
        få från företaget du har tecknat elnätsavtalet hos eller från den tidigare ägaren av
        bostaden.
      </li>
      <li class="mb-2">
        Vill du teckna ett elavtal med Skellefteå Kraft, men flyttar till ett område där vi inte
        äger elnätet, behöver vi veta vilket <b>startdatum</b> för elnätsavtalet du anmält till ditt
        elnätsbolag.
      </li>
      <li class="mb-2">
        Är ni flera vuxna som flyttar in tillsammans? Meddela <b>vem som ska ansvara för avtalen</b
        >. Elnätsavtalet och elavtalet behöver stå skrivna på samma person.
      </li>
    </ul>
  </div>
</Card>
<ExtensibleContent>
  {#snippet header()}
    <span>Vad är ett anvisat elavtal?</span>
  {/snippet}
  <p>
    När du flyttar eller skaffar en ny fastighet är elnätsföretaget dit du flyttar enligt lagen
    skyldiga att anvisa ett elhandelsföretag, så du får el till bostaden.
  </p>
  <p class="mt-2">
    Det så kallade anvisade elhandelsföretaget blir då det företag du köper el av, fram till att du
    själv väljer att teckna ett elavtal med ett annat elhandelsföretag. Ett anvisat avtal är oftast
    dyrare, vi hjälper dig hitta det elavtal som passar dig bäst.
  </p>
</ExtensibleContent>
<ExtensibleContent>
  {#snippet header()}
    <span>Vad är skillnaden mellan elnätsavtal och elavtal?</span>
  {/snippet}
  <a
    class="text-Violet700 hover:underline"
    target="_empty"
    href="https://www.skekraft.se/sv/faq/skillnaden-mellan-elnat-och-elhandel/#box-no-14992"
    >Här kan du läsa mer om skillnaden mellan elnätsavtal och elavtal</a
  >
</ExtensibleContent>
<Button animate={false} class="w-full mt-2" onClick={onClickContinue}>Ok, fortsätt</Button>
